import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const UIContext = createContext(null);
export const useUI = () => useContext(UIContext);

export function UIProvider({ children }) {
  const { user } = useAuth();
  const [detail, setDetail] = useState(null);
  const [myListIds, setMyListIds] = useState(new Set());

  const loadMyList = useCallback(async () => {
    if (!user) { setMyListIds(new Set()); return; }
    try {
      const { data } = await api.get("/mylist");
      setMyListIds(new Set(data.map((d) => d.id)));
    } catch {}
  }, [user]);

  useEffect(() => { loadMyList(); }, [loadMyList]);

  const openDetail = useCallback((content) => setDetail(content), []);
  const closeDetail = useCallback(() => setDetail(null), []);

  const toggleMyList = useCallback(async (content) => {
    if (!user) { toast.error("Sign in to build your list"); return; }
    const inList = myListIds.has(content.id);
    setMyListIds((prev) => {
      const n = new Set(prev);
      inList ? n.delete(content.id) : n.add(content.id);
      return n;
    });
    try {
      if (inList) { await api.delete(`/mylist/${content.id}`); toast("Removed from My List"); }
      else { await api.post(`/mylist/${content.id}`); toast.success("Added to My List"); }
    } catch { loadMyList(); }
  }, [user, myListIds, loadMyList]);

  return (
    <UIContext.Provider value={{ detail, openDetail, closeDetail, myListIds, toggleMyList, loadMyList }}>
      {children}
    </UIContext.Provider>
  );
}
